import { i18n, _t } from "app/i18n/i18n";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { isIntranetPath } from "lib/routing";
import { getAssetClass } from "pages/redesign/publications/api/searchRequest/urlHelpers";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { onMenuChange } from "../parts/onMenuChange";
import { getPeriodicalsFromMenuData, hideHeadings } from "./getPeriodicals";
import { getRegions } from "./getRegions";
import { getSubCategories } from "./getSubCategories";

export function useGetMenuBarData() {
  const location = useLocation();
  const assetClass = getAssetClass(location);
  const qs = useQueryParams();
  const menuData = useSelector((state) => state.misc.menuData);
  const lang = i18n.getLanguage();

  let menuOptions = {};
  try {
    menuOptions = getMenuBarData(menuData, assetClass, qs, lang);
  } catch (err) {
    console.warn("Error parsing menu data", err);
  }
  return menuOptions;
}

export function getMenuBarData(menuData, assetClass, qs, lang) {
  const region = qs.regions;
  const subCategory = flatten(qs[`txSubCategories.${lang}`]) || "";

  const regions = {
    values: [region || "All Regions"],
    options: getRegions(assetClass, subCategory),
    disabled: hasAnyRegionForAssetClass(menuData, assetClass),
    onChange: (ev) => onMenuChange("regions", ev.target.value),
    type: "radio",
  };

  const txSubCategories = {
    values: [subCategory || _t("All Categories")],
    options: getSubCategories(menuData, assetClass, region, lang, isIntranetPath()),
    onChange: (ev) => onMenuChange(`txSubCategories.${lang}`, ev.target.value),
    type: "radio",
  };
  txSubCategories.disabled = txSubCategories.options.length === 0;

  const periodicals = {};
  periodicals.values = [qs[`periodicals.${lang}`] || _t("All Periodicals")];
  periodicals.optionsWithHeadings = getPeriodicalsFromMenuData(menuData, assetClass, region, lang, periodicals.values);
  periodicals.options = hideHeadings(periodicals.optionsWithHeadings);
  periodicals.onChange = (ev) => onMenuChange(`periodicals.${lang}`, ev.target.value);
  periodicals.type = "radio";

  return { regions, txSubCategories, periodicals };
}

const flatten = (arr) => (arr?.join ? arr.join(", ") : arr);

const hasAnyRegionForAssetClass = (menuData, assetClass) => {
  if (!menuData || assetClass === "Home") return false;

  const periodicalsData = menuData["periodicals.en"]?.[assetClass];
  return periodicalsData ? "Any" in periodicalsData : false;
};
